import React, { useState, useEffect } from "react";
import ScrollTopButton from "./components/ScrollTopButton";
import "./AddSource.css";
import { createFragmentContainer, graphql } from "react-relay";
import AddSourceModalContainer from "./components/AddSourceModalContainer";
import { useNavigate } from "react-router-dom";
import { commitLocalUpdate } from "react-relay";
import environment from "./Environment";
import { useTheme } from "./contexts/ThemeContext";
import { useMediaQuery } from "react-responsive";
import FullSpanAddSourceModal from "./components/FullSpanAddSourceModal";

function AddSource(props) {
    const [scrolled, setScrolled] = useState(window.pageYOffset);
    let [coords, setCoords] = useState(document.documentElement.clientHeight);
    const { navigate } = useNavigate();
    const [isModalActive, setIsModalActive] = useState(false);
    // const [selectedSubId, setSelectedSubId] = useState("");
    // const [selectedSubName, setSelectedSubName] = useState("");
    const { email } = props.user;
    const [isSearchModalActive, setIsSearchModalActive] = useState(false);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    const {
        isFullScreenAddSourceModalActivated,
        isAddSourceModalActivated,
        isAddFeedBoxShown,
        selectedSubId,
        selectedSubName,
    } = props.settings;

    const settings = props.settings;
    const user = props.user;

    // console.log(selectedSubId);
    // console.log(selectedSubName);

    let [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // useEffect(() => {
    // 	document.addEventListener("contextmenu", (e) => {
    // 		e.preventDefault();
    // 	})
    // })

    const handleScroll = (e) => {
        e.preventDefault();

        if (window.pageYOffset + 500) {
            setScrolled(window.pageYOffset + 500);
        }
    };

    function onSubmit(e) {
        e.preventDefault();
        // updateLocalSetting("sourceString", searchValue);

        // console.log(props.allSources);
        // console.log("Submited source search!");
    }

    function onChange(e) {
        e.preventDefault();
        setSearchValue(e.target.value);
    }

    const setIsAddSourceModalActivated = (value) => {
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(value, "isAddSourceModalActivated");
        });
    };

    function onAddClick(e) {
        e.preventDefault();
        setIsModalActive(true);
        // setSelectedSubId(e.target.dataset.id);
        // setSelectedSubName(e.target.dataset.name);
        console.log(e.target.dataset.id);
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isFullScreenAddSourceModalActivated");
            record.setValue(true, "isAddSourceModalActivated");
            record.setValue(e.target.dataset.id, "selectedSubId");
            record.setValue(e.target.dataset.name, "selectedSubName");
            record.setValue([e.target.dataset.id], "selectedNodeId");
            record.setValue(false, "isParent");
            record.setValue(false, "allSubscriptions");
            record.setValue(e.target.dataset.name, "metaSourceName");
            record.setValue("Articles from ", "metaDescription");
        });
    }

    function onBackClick(e) {
        e.preventDefault();
        navigate("/home");
    }

    function onSearchSourceClick(e) {
        e.preventDefault();
        setIsSearchModalActive(true);
    }

    function onAddLinkClick(e) {
        e.preventDefault();
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(true, "isAddFeedBoxShown");
        });
    }

    function trimText(text, trimLength) {
        if (text != null && text != "") {
            if (text.length > trimLength) {
                return text.slice(0, trimLength) + "...";
            } else {
                return text;
            }
        } else {
            return text;
        }
    }

    // useEffect(() => {
    // 	return () => {
    // 		updateLocalSetting("sourceString", "kjaslkdjflkasjdfh");
    // 	};
    // });

    let showHeader = scrolled > coords ? "true" : "false";

    function getBestValue(value, editedValue) {
        if (editedValue) {
            return editedValue;
        } else {
            return value;
        }
    }

    return (
        <div>
            <div className="source-search-results">
                {props.allSources.edges.length != 0 ? (
                    <div className="source-container">
                        <div>
                            {props.allSources.edges.map((edge) => (
                                <div
                                    className={`single-source-container theme-${theme.overlay}`}
                                    key={edge.node.id}
                                >
                                    <div className="single-source">
                                        <div className="single-source-source-image">
                                            <img
                                                className="add-source-source-icon"
                                                src={edge.node.source_icon}
                                                alt=""
                                            />
                                        </div>

                                        <div
                                            className={`single-source-info theme-${theme.paragraph}`}
                                        >
                                            {isSmallScreen ? (
                                                <span className="source-name">
                                                    {edge.node.edited_name ? (
                                                        <div>
                                                            <p>
                                                                {trimText(
                                                                    edge.node
                                                                        .edited_name,
                                                                    30
                                                                )}
                                                            </p>
                                                            <p className="source-description">
                                                                {trimText(
                                                                    edge.node
                                                                        .edited_description,
                                                                    30
                                                                )}
                                                            </p>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <p>
                                                                {trimText(
                                                                    edge.node
                                                                        .name,
                                                                    30
                                                                )}
                                                            </p>
                                                            <p className="source-description">
                                                                {trimText(
                                                                    edge.node
                                                                        .description,
                                                                    30
                                                                )}{" "}
                                                            </p>
                                                        </div>
                                                    )}
                                                </span>
                                            ) : (
                                                <span className="source-name">
                                                    {edge.node.edited_name ? (
                                                        <div>
                                                            <p>
                                                                {trimText(
                                                                    edge.node
                                                                        .edited_name,
                                                                    50
                                                                )}
                                                            </p>
                                                            <p className="source-description">
                                                                {trimText(
                                                                    edge.node
                                                                        .edited_description,
                                                                    50
                                                                )}{" "}
                                                            </p>
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <p>
                                                                {trimText(
                                                                    edge.node
                                                                        .name,
                                                                    50
                                                                )}
                                                            </p>
                                                            <p className="source-description">
                                                                {trimText(
                                                                    edge.node
                                                                        .description,
                                                                    50
                                                                )}{" "}
                                                            </p>
                                                        </div>
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                    </div>

                                    <div className={`source-subscribe `}>
                                        <div className="btn-source-subscribe">
                                            <button
                                                className="source-add-button"
                                                onClick={onAddClick}
                                                data-id={edge.node.id}
                                                data-name={getBestValue(
                                                    edge.node.name,
                                                    edge.node.edited_name
                                                )}
                                            >
                                                Add
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <div className="empty-source-container">
                        <span>
                            <h3 thme={`theme-${theme.foreground}}`}>
                                Sorry! Unable to find what you are searching
                                for! You can add a feed instead.
                            </h3>
                        </span>
                        <span>
                            <button
                                onClick={onAddLinkClick}
                                className="standard-action-button"
                            >
                                {" "}
                                Add Link{" "}
                            </button>
                        </span>
                    </div>
                )}
            </div>
            {isSmallScreen ? (
                <div>
                    {isFullScreenAddSourceModalActivated ? (
                        <div>
                            <FullSpanAddSourceModal
                                isModalActive={true}
                                selectedSubId={selectedSubId}
                                selectedSubName={selectedSubName}
                                subscriptions={props.subscriptions}
                                settings={settings}
                                user={user}
                            />
                        </div>
                    ) : null}
                </div>
            ) : (
                <div>
                    {isAddSourceModalActivated ? (
                        <div>
                            <AddSourceModalContainer
                                title="Add New Source"
                                isModalActive={isAddSourceModalActivated}
                                setIsModalActive={setIsAddSourceModalActivated}
                                selectedSubId={selectedSubId}
                                selectedSubName={selectedSubName}
                                settings={props.settings}
                            />
                        </div>
                    ) : null}
                </div>
            )}
            <ScrollTopButton />
            {/*
			
				</div>
			</div>
			*/}
        </div>
    );
}

export default createFragmentContainer(AddSource, {
    allSources: graphql`
        fragment AddSource_allSources on SourceNodeConnection {
            edges {
                node {
                    id
                    name
                    edited_name
                    description
                    edited_description
                    image_url
                    source_icon
                }
            }
        }
    `,
});
